const startAtt = [-60, -55, -50, -40, -40, -35, -30] //original [-60, -65, -60, -50, -50, -45, -40];
const maxAtt = [-90, -100, -95, -90, -85, -85, -85]
const corr = [-10, -5, -5, 0, -5, 0, 5]
const tones = [
  "audio-1kHz",
  "audio-2kHz",
  "audio-4kHz",
  "audio-8kHz",
  "audio-500Hz",
  "audio-250Hz",
  "audio-125Hz",
]
const tonesMap = {
  "audio-1kHz": "1kHz",
  "audio-2kHz": "2kHz",
  "audio-4kHz": "4kHz",
  "audio-8kHz": "8kHz",
  "audio-500Hz": "500Hz",
  "audio-250Hz": "250Hz",
  "audio-125Hz": "125Hz"
}
const rangeKeys = [
  "125Hz",
  "250Hz",
  "500Hz",
  "1kHz",
  "2kHz",
  "4kHz",
  "8kHz"
]

const defaultChartOptions = {
  tickColor: "rgba(0, 0, 0, 0)",
  gridColor: "rgba(0, 0, 0, .2)",
  lineColor: "rgba(0, 0, 0, .2)",
  labelFontColor: "rgba(0, 0, 0, .2)",
  titleFontColor: "rgba(0, 0, 0, .2)",
  titleFontSize: 14,
  labelFontWeight: "normal",
  labelFontSize: 14,
  lineThickness: 1,
}

const exportChartOptions = {
  titleFontColor: "rgba(0, 0, 0, 1)",
  titleFontSize: 30,
  labelFontColor: "rgba(0, 0, 0, 1)",
  labelFontWeight: "bold",
  labelFontSize: 18,
  lineThickness: 2,
}


export {
  startAtt,
  maxAtt,
  corr,
  tones,
  tonesMap,
  rangeKeys,
  defaultChartOptions,
  exportChartOptions,
}
